angular.module('v3sWbtPlayerApp').factory('v3sScormDataLmsService', ["v3sScormDataLmsAdapterService", "v3sScormDataLms2004AdapterService", "v3sCompressionService", "v3sServiceFinder", "v3sUserService", "v3sLog", "v3sChangeCheckerService", "v3sWbtVarService", "v3sExtensionsConfig", "v3sNavigationService", "$q", "$timeout", function (v3sScormDataLmsAdapterService, v3sScormDataLms2004AdapterService, v3sCompressionService, v3sServiceFinder, v3sUserService, v3sLog, v3sChangeCheckerService, v3sWbtVarService, v3sExtensionsConfig, v3sNavigationService, $q, $timeout) {
    var v3sWbtSettingsService = v3sServiceFinder.get("v3sWbtSettingsService");
    var v3sStructureSco = v3sServiceFinder.get("v3sStructureSco");

    var itemData = null;
    var wbt = null;
    var monolith = NaN;
    var globalSuspendData = {};

    var deferredLoaded = null;
    var deferredInitialized = null;
    var timeoutInitialized = null;
    var adapter = null;
    var scoStatusLoaded = true;

    var changeChecker = null;
    var initTime = 0;

    var entry = "";
    var location = "";
    var lastVisit = NaN;
    var lastLoadedScormData = null;

    function selectLmsApiAdapter(mode) {
        if (adapter == null) {
            if (mode == "scorm2004") {
                v3sLog.debug("SCORM 2004 Adapter is selected.");
                adapter = v3sScormDataLms2004AdapterService;
            } else if (mode == "scorm12") {
                v3sLog.debug("SCORM 1.2 Adapter is selected.");
                adapter = v3sScormDataLmsAdapterService;
            } else {
                try {
                    if (v3sScormDataLms2004AdapterService.getAPI()) {
                        v3sLog.debug("SCORM 2004 Adapter found.");
                        adapter = v3sScormDataLms2004AdapterService;
                    } else if (v3sScormDataLmsAdapterService.getAPI()) {
                        v3sLog.debug("SCORM 1.2 Adapter found.");
                        adapter = v3sScormDataLmsAdapterService;
                    }
                } catch (e) {
                    v3sLog.warn("Exception: ", false, e);
                }
            }
        }

        return !!adapter;
    }

    function initialize(mode, showSuccessMessage) {
        if (!deferredInitialized) {
            deferredInitialized = $q.defer();
        }

        try {
            if (adapter == null) {
                selectLmsApiAdapter(mode);
            }

            if (!adapter.isInitialized()) {
                adapter.initialize();
            }

            if (showSuccessMessage) {
                v3sLog.close("general.lmsnotfound");
                v3sLog.success("general.lmsfound", true);
            }

            deferredInitialized.resolve(true);
        } catch (e) {
            v3sLog.warn("Exception: ", false, e);

            if (!timeoutInitialized) {
                timeoutInitialized = $timeout(function () {
                    initialize(mode);
                }, 1000);
            } else {
                v3sLog.error(
                    'general.lmsnotfound',
                    "Could not retrieve scorm data from the LMS",
                    {
                        actions: [{
                            name: 'general.retry',
                            action: function () {
                                v3sLog.close("general.lmsnotfound");
                                initialize(mode, true);
                            }
                        }]
                    });
            }
        }

        return deferredInitialized.promise;
    }

    function load(data, mode) {
        itemData = data;
        wbt = itemData.getWbt();
        monolith = itemData == wbt;

        location = "";
        lastVisit = NaN;

        return initialize(mode).then(function () {
            return loadLmsData(data, mode);
        });
    }


    function loadLmsData(data, mode, showSuccessMessage) {
        if (!deferredLoaded) {
            deferredLoaded = $q.defer();
        }
        
        try {
            var status = adapter.getValue(adapter.VARS.STATUS_COMPLETED);
            itemData.setStatus(status, { overwrite: true });

            // Überschreibe Score aus suspend_data, falls LMS einen Score liefert und nicht Score als Fortschritt gespeichert wird
            if (!monolith || adapter !== v3sScormDataLmsAdapterService || !v3sExtensionsConfig.enableProgressAsScore) {
                try {
                    var score = adapter.getValue(adapter.VARS.SCORE_RAW);
                    itemData.setScore(score, { overwrite: true });
                } catch (e) {
                    v3sLog.warn("Exception: ", false, e);
                    v3sLog.warn("Could not retrieve score from the LMS");
                }
            }

            if ((adapter != v3sScormDataLms2004AdapterService || (status != "" && status != "not attempted" && status != "unknown")) && !(itemData instanceof v3sStructureSco) && itemData.isTrackable()) {
                var scormData = adapter.getValue(adapter.VARS.SUSPEND_DATA);
                if (!!scormData) {
                    scormData = v3sCompressionService.decompress(scormData);
                    if (!!scormData) {
                        if (!angular.isArray(scormData)) {
                            if (monolith) {
                                loadGlobalData(scormData);
                            }
                        } else if (scormData.length > 1) {
                            //obsolete
                            itemData.setScormData(scormData[0]);
                        }
                    }
                }
            }

            if (!monolith) {
                scoStatusLoaded = false;
                var globalData = adapter.getGlobalData();
                if (!!globalData) {
                    globalData = v3sCompressionService.decompress(globalData);
                    loadGlobalData(globalData);
                }
            }

            try {
                var studentId = adapter.getValue(adapter.VARS.STUDENT_ID);
                var studentName = adapter.getValue(adapter.VARS.STUDENT_NAME);
                v3sUserService.set("id", studentId, true);
                v3sUserService.set("name", studentName, true);
            } catch (e) {
                v3sLog.warn("Exception: ", false, e);
                v3sLog.warn("Could not retrieve user data from the LMS");
            }

            initTime = (new Date()).getTime();
            initChangeChecker();

            if (showSuccessMessage) {
                v3sLog.close("general.lmsdatanotfound");
                v3sLog.success("general.lmsdatafound", true);
            }

            deferredLoaded.resolve(true);

        } catch (e) {
            v3sLog.warn("Exception: ", false, e);
            v3sLog.error(
                'general.lmsdatanotfound',
                "Could not retrieve scorm data from the LMS: " + e,
                {
                    actions: [{
                        name: 'general.retry',
                        action: function () {
                            v3sLog.close("general.lmsdatanotfound");
                            loadLmsData(data, mode, true);
                        }
                    }]
                });
        }

        return deferredLoaded.promise;
    }

    function loadGlobalData(globalData) {
        if (!!globalData) {
            entry = "";
            location = "";
            lastVisit = NaN;

            lastLoadedScormData = globalData;
            globalSuspendData = angular.copy(globalData);

            if (v3sWbtSettingsService) v3sWbtSettingsService.set(globalSuspendData.settings);
            v3sUserService.setUserScormData(globalSuspendData.user);
            v3sWbtVarService.setVars(globalSuspendData.vars);

            wbt.setGlobalScormData(globalSuspendData.scoStatus);
            scoStatusLoaded = true;

            if (globalSuspendData.lastChange) {
                lastVisit = globalSuspendData.lastChange;
            }

            var secondsSinceLastVisit = (new Date()).getTime() / 1000 - lastVisit;

            if (secondsSinceLastVisit < 5 && !!globalSuspendData.entry) { // Entry max. vor 5 Sek. erstellt)
                entry = globalSuspendData.entry;
            }

            if (!entry && !!globalSuspendData.location &&
                ((!adapter.VARS.NAV_MODE && secondsSinceLastVisit > 5) || !getSaveNavMode())) {
                location = globalSuspendData.location;
            }

            //reset
            globalSuspendData.entry = "";
            globalSuspendData.location = "";
        }
    }

    function getSaveNavMode() {
        var navMode = "";

        try {
            if (!!adapter.VARS.NAV_MODE && !monolith) {
                navMode = adapter.getValue(adapter.VARS.NAV_MODE);
            }
        } catch (e) {
            v3sLog.warn("Exception: ", false, e);
        }

        return navMode;
    }

    function save() {
        var saved = false;

        if (!!changeChecker && !!adapter) {
            saved = changeChecker.saveChanges();
        }

        return saved;
    }

    function initChangeChecker() {
        changeChecker = new v3sChangeCheckerService([wbt, v3sUserService, v3sWbtSettingsService]);

        changeChecker.start(function saveCallback(changesCount) {
            var saved = false;

            try {
                if (changesCount !== 0 || !!globalSuspendData.entry) {

                    globalSuspendData.scoStatus = wbt.getGlobalScormData();
                    if (v3sWbtSettingsService) globalSuspendData.settings = v3sWbtSettingsService.get();
                    globalSuspendData.user = v3sUserService.getUserScormData();
                    globalSuspendData.vars = v3sWbtVarService.getVars();
                    globalSuspendData.lastChange = 0;
                    globalSuspendData.location = v3sNavigationService.getLastPageId();

                    if (!!lastLoadedScormData) lastLoadedScormData.lastChange = 0; //ignore lastChange by compare
                    if (!angular.equals(globalSuspendData, lastLoadedScormData)) {
                        globalSuspendData.lastChange = Math.floor((new Date()).getTime() / 1000);
                        var scormData = v3sCompressionService.compress(globalSuspendData);
                        if (monolith) {
                            adapter.setValue(adapter.VARS.SUSPEND_DATA, scormData);
                        } else {
                            adapter.setGlobalData(scormData);
                            adapter.setValue(adapter.VARS.SUSPEND_DATA, ""); //delete obsolete suspend data
                        }
                    }

                    if (!(itemData instanceof v3sStructureSco) && itemData.isTrackable()) {
                        var score = itemData.getScore();
                        var status = itemData.getStatus();
                        var progress = itemData.getProgress();
                        var exerciseStatus = itemData.getExerciseStatus();

                        var hasTest = itemData.getTestSco && itemData.getTestSco();

                        if (monolith) {
                            if (adapter === v3sScormDataLmsAdapterService) {
                                if (v3sExtensionsConfig.enableLMSReportTestStatusAsPassed) {
                                    if (v3sExtensionsConfig.enableConsiderOnlyTestScore && hasTest) {
                                        if (itemData.getTestSco().isCompleted()) {
                                            status = itemData.getTestSco().getExerciseStatus();
                                        }

                                    } else if (itemData.isCompleted()) {
                                        status = exerciseStatus;
                                    }

                                } else if (v3sExtensionsConfig.enableConsiderOnlyTestScore && hasTest) {
                                    status = itemData.getTestSco().getStatus();
                                }
                            } else if (v3sExtensionsConfig.enableConsiderOnlyTestScore && hasTest) {
                                if (itemData.getTestSco().isCompleted()) {
                                    exerciseStatus = itemData.getTestSco().getExerciseStatus();
                                } else {
                                    exerciseStatus = "unknown";
                                }                                
                            }
                        }

                        if (status === "not attempted") {
                            status = "incomplete"; // Es gab keine Änderungen, Status muss trotzdem an LMS wegen Timeout gesendet werden
                        }
                        adapter.setValue(adapter.VARS.STATUS_COMPLETED, status);

                        if (monolith && v3sExtensionsConfig.enableConsiderOnlyTestScore && hasTest) {
                            score = itemData.getTestSco().getScore();
                        }

                        if (monolith && adapter === v3sScormDataLmsAdapterService && v3sExtensionsConfig.enableProgressAsScore) {
                            score = Math.floor(progress.completed * 100 / progress.count);

                        } else if (adapter === v3sScormDataLms2004AdapterService) {
                            adapter.setValue(adapter.VARS.PROGRESS, progress.completed / progress.count);
                        }

                        if (score > 0 || exerciseStatus === "failed" || (monolith && v3sExtensionsConfig.enableConsiderOnlyTestScore && hasTest)) {
                            adapter.setValue(adapter.VARS.STATUS_PASSED, exerciseStatus);
                            adapter.setValue(adapter.VARS.SCORE_RAW, score.toString());
                            adapter.setValue(adapter.VARS.SCORE_SCALED, (score / 100).toString());
                            adapter.setValue(adapter.VARS.SCORE_MIN, "0");
                            adapter.setValue(adapter.VARS.SCORE_MAX, "100");
                        }
                    } else if (adapter === v3sScormDataLms2004AdapterService) {
                        // kein "trackable" bei Scorm2004
                        adapter.setValue(adapter.VARS.STATUS_COMPLETED, "completed");
                    }
                }

                adapter.setValue(adapter.VARS.LOCATION, v3sNavigationService.getLastPageId());

                adapter.commit();
                saved = true;

                if (!changeChecker.isLastSaved()) { //Erfolgsmeldung nur dann anzeigen, falls vorher Fehler auftratt
                    v3sLog.close("scormdatanotsaved");
                    v3sLog.success("general.scormdatasaved", true);
                }
            } catch (e) {
                v3sLog.warn("Exception: ", false, e);
                v3sLog.close("general.scormdatasaved");
                v3sLog.error(
                    "general.scormdatanotsaved",
                    "Could not save ScormData to the LMS",
                    {
                        time: Math.floor(changeChecker.geTimeSinceLastSave() / 1000 + 2),
                        actions: [{
                            name: 'general.retry',
                            action: function () {
                                v3sLog.close("general.scormdatanotsaved");
                                changeChecker.saveChanges();
                            }
                        }, {
                            name: 'general.cancel',
                            action: function () {
                                v3sLog.close("general.scormdatanotsaved");
                            }
                        }]
                    });
            }

            return saved;
        },
        1000);

        changeChecker.setForcedChange();
        changeChecker.saveChanges();
    }

    function close(forced) {
        var closed = false;

        if (!!adapter) {
            try {
                if (!!changeChecker) {
                    changeChecker.setForcedChange();
                    changeChecker.saveChanges();

                    if (!!forced || changeChecker.isLastSaved()) {

                        if (initTime > 0) {
                            var sessionTime = Math.floor(((new Date()).getTime() - initTime) / 1000);

                            var ss = Math.floor(sessionTime % 60);
                            sessionTime = sessionTime / 60;
                            var mm = Math.floor(sessionTime % 60);
                            sessionTime = sessionTime / 60;
                            var hh = Math.floor(sessionTime % 24);

                            var time = "";
                            if (adapter == v3sScormDataLms2004AdapterService) {
                                time = "PT" + hh + "H" + mm + "M" + ss + "S";
                            } else {
                                time = (hh < 10) ? ("0" + hh) : hh;
                                time += ":";
                                time += (mm < 10) ? ("0" + mm) : mm;
                                time += ":";
                                time += (ss < 10) ? ("0" + ss) : ss;
                            }

                            initTime = 0;
                            adapter.setValue(adapter.VARS.SESSION_TIME, time.toString());
                        }

                        adapter.finish(forced);
                        changeChecker.stop();
                        adapter = null;
                        changeChecker = null;
                        closed = true;
                    }
                }
            } catch (e) {
                v3sLog.warn("Exception: ", false, e);
                v3sLog.warn("Could not terminate communication with the LMS");
                v3sLog.error('general.lmsnotterminate');
                closed = !!forced;
            }
        } else {
            closed = true;
        }

        return closed;
    }

    function hasSco(scoId) {
        var result = false;

        try {
            result = adapter.VARS.SCORM_TRUE.value === adapter.getValue(adapter.VARS.VALID_REQUEST_CHOICE, scoId);
        } catch (e) {
            v3sLog.warn("Exception: ", false, e);
            v3sLog.warn("Could not get specific SCO");
        }

        return result;
    }

    function goToSco(scoId, entry) {
        var result = false;

        try {
            adapter.setValue(adapter.VARS.NAV_REQUEST, adapter.VARS.NAV_REQUEST_CHOICE, scoId);
            globalSuspendData.entry = entry;
            result = true;
        } catch (e) {
            v3sLog.warn("Exception: ", false, e);
            v3sLog.warn("Could not navigate to specific SCO");
            v3sLog.error("general.sconavigationerror");
        }

        return result;
    }

    function getEntry() {
        return entry;
    }

    function getLocation() {
        return location;
    }

    function getLastVisit() {
        return lastVisit * 1000;
    }

    function isScoStatusLoaded() {
        return scoStatusLoaded;
    }

    return {
        load: load,
        close: close,
        save: save,
        hasSco: hasSco,
        goToSco: goToSco,
        getEntry: getEntry,
        getLocation: getLocation,
        isScoStatusLoaded: isScoStatusLoaded,
        selectLmsApiAdapter: selectLmsApiAdapter,
        getLastVisit: getLastVisit
    };
}]);